import React, { useEffect, useState } from 'react'
import delet from '../../../Assets/Images/delete.svg';
import edit from '../../../Assets/Images/edit.svg';
import Popup from 'reactjs-popup';
import { useProducts } from '../../../Context/ProductsContext';
import DeletModal from '../../DeleteModel/DeletModal';
import { Link, useParams } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import LoadingOverlay from '../../LoadingOverlay/LoadingOverlay';

function SubBrandTable() {
  const { getProductsSubBrand, isProductsSubBrand, deleteProductsSubBrand } = useProducts();
  const { lang } = useParams();

  useEffect(() => {
    getProductsSubBrand(lang);
  }, []);

  const handleDeleteProductsSubBrand = async (id) => {
    try {
      await deleteProductsSubBrand(id, lang);
      toast.success("Products Sub Brand deleted successfully!");
    } catch (error) {
      if (error.response && error.response.data) {
        // Show the backend error message
        toast.error(error.response.data.message || "Error deleting Products Sub Brand!");
      } else {
        // Generic fallback error
        toast.error("Error deleting Products Sub Brand!");
      }
    }
  };

  return (
    <div className='bg-[#fff] rounded-2xl p-3'>
      <ToastContainer autoClose={4000} pauseOnFocusLoss={false} pauseOnHover={false} />
      {!isProductsSubBrand && <LoadingOverlay />} {/* Display loading overlay */}
      <table className='w-full border-collapse mb-6'>
        <thead>
          <tr className='p-2'>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '15%' }}>SN</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Name</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Brand</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Status</th>
            <th className='text-[16px] font-[500] text-[#0966AE] font-[Cairo] py-2 px-5 text-start' style={{ width: '25%' }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {isProductsSubBrand?.data?.map((product, index) => (
            <tr key={index}>
              <td className='p-5 text-start' style={{ width: '15%' }}>{String(index + 1).padStart(2, '0') + "."}</td>
              <td className='p-5 text-start' style={{ width: '25%' }}>{product.name}</td>
              <td className='p-5 text-start' style={{ width: '25%' }}>{product?.brand?.name}</td>
              <td className='p-5 text-start' style={{ width: '25%' }}>
                <div className={product.status == 1 ?
                  'bg-[#0966AE] text-[#fff] p-2 w-[75px] rounded-md border text-center' :
                  'bg-[#ffc107] p-2 w-[75px] rounded-md border text-center'}>
                  {product.status == 1 ? "Publish" : "Draft"}
                </div></td>
              <td className='p-5 text-center' style={{ width: '25%' }}>
                <div className='flex gap-2 items-center'>
                  <Link to={`/Products/EditSubBrand/${product.id}`}>
                    <div className='bg-[#148342] p-2 w-[40px] cursor-pointer rounded-md border'>
                      <img src={edit} alt="" />
                    </div>
                  </Link>
                  <Popup
                    trigger={
                      <div className='bg-[#AF1F24] p-2 w-[40px] cursor-pointer rounded-md border'>
                        <img src={delet} alt="" />
                      </div>
                    }
                    modal
                    nested
                  >
                    {(close) => (
                      <div className="modal">
                        <DeletModal close={close} id={product.id} onDelete={() => handleDeleteProductsSubBrand(product.id)} />
                      </div>
                    )}
                  </Popup>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default SubBrandTable;